import React from 'react'
import './Footer.css'

export const Footer = () => {
  return (
    <div className="footer">
    <h2 className='appName'>NewsMonkey</h2>
    </div>
  )
}

export default Footer;
